import iztoas from 'izitoast'

export default {
    error: (message, data) => {
        iztoas.error(
            Object.assign({
                message: message,
                timeout: 7000,
                position: "topRight",
                transitionIn: 'fadeInLeft',
                transitionOut: 'fadeOutRight',
                close: true,
                backgroundColor: '#ff3860',
                messageColor: '#fff',
                titleColor: '#fff',
                messageSize: '15',
                rtl: true
            }, data)
        )
    },
    success: (message, data) => {
        iztoas.success(
            Object.assign({
                message: message,
                timeout: 7000,
                position: "topRight",
                transitionIn: 'fadeInLeft',
                transitionOut: 'fadeOutRight',
                close: true,
                backgroundColor: '#4bc5bd',
                messageColor: '#fff',
                titleColor: '#fff',
                messageSize: '15',
                rtl: true
            }, data)
        )
    },
    info: (message, data) => {
        iztoas.info(
            Object.assign({
                message: message,
                timeout: 7000,
                position: "topRight",
                transitionIn: 'fadeInLeft',
                transitionOut: 'fadeOutRight',
                overlay: false,
                close: true,
                backgroundColor: '#3273dc',
                messageColor: '#fff',
                titleColor: '#fff',
                messageSize: '15',
                rtl: true
            }, data)
        )
    },
    warning: (message, data) => {
        iztoas.warning(
            Object.assign({
                message: message,
                timeout: 7000,
                position: "topRight",
                transitionIn: 'fadeInLeft',
                transitionOut: 'fadeOutRight',
                overlay: false,
                close: true,
                backgroundColor: '#dc954c',
                messageColor: '#fff',
                titleColor: '#fff',
                messageSize: '15',
                rtl: true
            }, data)
        )
    },
}